import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { HammerModule } from '@angular/platform-browser';

import { MgIconModule } from '@app/src/app/icon';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { TilesCarouselComponent } from './tiles-carousel.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgSpinnerModule,
    MgIconModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatTabsModule,
    ObserversModule,
    HammerModule,
  ],
  declarations: [TilesCarouselComponent],
  exports: [TilesCarouselComponent],
})
export class TilesCarouselModule {}
